import { render } from "./ShoppingCartList.vue?vue&type=template&id=7a25b3ba"
import script from "./ShoppingCartList.vue?vue&type=script&lang=js"
export * from "./ShoppingCartList.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__